import { render, staticRenderFns } from "./EmailListingDomainAuthBanner.vue?vue&type=template&id=8074e816&scoped=true&"
import script from "./EmailListingDomainAuthBanner.vue?vue&type=script&lang=js&"
export * from "./EmailListingDomainAuthBanner.vue?vue&type=script&lang=js&"
import style0 from "./EmailListingDomainAuthBanner.vue?vue&type=style&index=0&id=8074e816&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8074e816",
  null
  
)

export default component.exports